export class ResourceLock {
    resourcesLockId: string
    companyId: string
    label: string
    createdAt: Date
    updatedAt: Date
    status: number
}
